/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import AchievementLevel from './AchievementLevel';
import AchievementHeader from './AchievementHeader';
import Link from 'flarum/common/components/Link';
export default class AchievementItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const {
      achievement,
      header,
      showDetails,
      link,
      clickable
    } = this.attrs;
    if (!achievement) {
      return null;
    }
    return m(Link, {
      className: `AchievementItem ${clickable ? 'AchievementItem--clickable' : ''}`,
      "data-id": achievement.id(),
      href: link
    }, header ? header : m(AchievementHeader, {
      achievement: achievement,
      showDesc: showDetails
    }), !!achievement.levels()?.length && showDetails && m("div", {
      className: "AchievementItem-levels AchievementItem-levels--summarized"
    }, achievement.levels()?.slice(0, 4).map(level => m(AchievementLevel, {
      achievementLevel: level
    })), achievement.levels()?.length > 4 && m(AchievementLevel, {
      more: achievement.levels()?.length - 4,
      link: link
    })));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/components/AchievementItem', AchievementItem);